import { render } from "./OnboardingUI.vue?vue&type=template&id=69ed9ac4"
import script from "./OnboardingUI.vue?vue&type=script&lang=ts"
export * from "./OnboardingUI.vue?vue&type=script&lang=ts"

import "./OnboardingUI.vue?vue&type=style&index=0&id=69ed9ac4&lang=scss"
script.render = render

export default script